import PermissionsTab from "@features/security/components/PermissionsTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { KeyRound } from "lucide-react";

export const Route = createFileRoute("/_app/admin/permissions/")({
  loader: requirePermission(PERMISSIONS.SECURITY.PERMISSIONS.VIEW),
  staticData: {
    title: "Permissions",
    icon: KeyRound,
    permission: PERMISSIONS.SECURITY.PERMISSIONS.VIEW,
    module: "security",
    section: "Administration",
    order: 30,
    showInTab: true,
  },
  component: PermissionsTab,
});
